import React, { Component } from 'react';
import {connect} from 'react-redux'
import {checkCallbackLogin} from '../../actions'

class Callback extends Component {

    componentDidMount() {
        this.props.handleCheckCallback()
    }

    render() {
        const style = {
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            height: '100vh',
            width: '100vw',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: 'white',
        }

        return (
            <div style={style}>
                Loading
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        handleCheckCallback: () => {
            dispatch( checkCallbackLogin() );
        },
    }
}

export default connect(null, mapDispatchToProps)(Callback);


// WEBPACK FOOTER //
// ./src/components/Callback/Callback.js